import { Actor, Canvas, Random, vec } from 'excalibur';
import { DESIGN_WIDTH, SEEDS, START_LIVES } from '../utils/constants';
import { Palette } from '../utils/palette';
import { drawHeart } from '../utils/sketch';

export class Hearts extends Actor {
  private hearts = START_LIVES;
  private readonly maxHearts = START_LIVES;
  private readonly heartCanvas: Canvas;

  constructor() {
    const canvas = new Canvas({
      width: START_LIVES * 52 + 8,
      height: 58,
      cache: true,
      draw: (ctx) => this.paint(ctx),
    });
    super({
      name: 'lives-hearts',
      pos: vec(DESIGN_WIDTH - 34, 56),
      anchor: vec(1, 0.5),
      graphic: canvas,
    });
    this.heartCanvas = canvas;
  }

  setHearts(count: number): void {
    this.hearts = Math.max(0, Math.min(this.maxHearts, count));
    this.heartCanvas.flagDirty();
  }

  reset(): void {
    this.setHearts(START_LIVES);
  }

  refreshTheme(): void {
    this.heartCanvas.flagDirty();
  }

  private paint(ctx: CanvasRenderingContext2D): void {
    for (let i = 0; i < this.maxHearts; i++) {
      const cx = 30 + i * 52;
      const rng = new Random(SEEDS.hearts + i * 17);
      if (i < this.hearts) {
        drawHeart(ctx, cx, 29, 42, rng, Palette.heart, Palette.heartDeep, 0.95);
      } else {
        drawHeart(ctx, cx, 29, 40, rng, Palette.paperEdge, Palette.inkSoft, 0.35);
      }
    }
  }
}
